import { UserProps } from '../../../types/reduxTypes/user';

export const getInitialState = (): UserProps => ({
  id: -1
});
